module.exports = __webpack_public_path__ + "img/devices.9bcafab7.svg";